<template>
  <div>
    <v-card class="mt-8" elevation="8">
      <div class="grid_half pa-6">
        <div class="mt-3">ชื่อหัวเรื่อง</div>
        <div class="mt-3 pa">
          <v-text-field color="#86bc3a" label="หัวเรื่อง" prepend-inner-icon="mdi-pencil" :rules="[v => !!v || 'กรุณากรอกหัวเรื่อง']" hide-details="auto" required v-model="title_name" outlined></v-text-field>
        </div>
      </div>
      <div class="pa-6">
        <div class="mt-3">เนื้อหา</div>
        <quillEditor ref="myQuillEditor" v-model="content" :options="editorOption"/>
      </div>
      <div class="text-center pb-4">
        <v-btn large @click="createAbout()" class="pa-6 mobile_btn grad-success-bg white--text" style="font-size: 18px">บันทึกข้อมูล</v-btn>
        <v-btn large class="pa-6 mobile_btn grad-danger-bg white--text" style="font-size: 18px">ยกเลิก</v-btn>
      </div>
    </v-card>
  </div>
</template>

<script>
import 'quill/dist/quill.core.css' // import styles
import 'quill/dist/quill.snow.css' // for snow theme
import 'quill/dist/quill.bubble.css' // for bubble theme
import {quillEditor} from 'vue-quill-editor'
import { HTTP } from '@/axios.js'
import Swal from 'sweetalert2'

export default {
  name: "ManageData",
  components: {
    quillEditor
  },
  data() {
    return {
      content: '',
      editorOption: {
        modules: {
          toolbar: ['bold', 'italic', 'underline', 'strike']
        }
      },
      title_name: null,
    }
  },
  methods: {
    createAlert() {
      Swal.fire('บันทึกข้อมูลเรียบร้อย','', 'success',);
    },
    createAbout() {
      HTTP.post('/manage-website/aboutus/create', {
        title: this.title_name,
        content: this.content
      }, {
        headers: {
          "Authorization": null
        }
      }).then((res) => {
        if (res.data.success === true){
          this.title_name = null;
          this.content = null;
          this.createAlert();
        }
      })
    }
  },
  computed: {
    editor() {
      return this.$refs.myQuillEditor.quill
    }
  },
}
</script>

<style scoped>
.grid_half {
  display: grid;
  grid-template-columns: 45%;
}
.mobile_btn {
  margin: 5px;
}
@media only screen and (max-width: 1180px) {
  .grid_half {
    display: grid;
    grid-template-columns: 50%;
  }
}
@media only screen and (max-width: 550px) {
  .grid_half {
    display: grid;
    grid-template-columns: 100%;
  }
  .mobile_btn {
    width: 90%;
  }
}
</style>
